export function formatRelativeTime(date: Date): string {
  const time = date.getTime();
  if (Number.isNaN(time)) {
    return '';
  }

  const diffMs = Date.now() - time;
  if (diffMs < 0) {
    return 'just now';
  }

  const diffMin = Math.floor(diffMs / 60_000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH}h ago`;
  return `${Math.floor(diffH / 24)}d ago`;
}
